<template>
	<div>
		<ManageLoanItem :data="localData" @showInstallments="tab = 'installments'" @loadData="loadData" @removed="$emit('removed')">
			<div v-if="tab === 'installments'" class="pa-3">
				<loan-installments :data="{ userloan: localData, adminPanel: true, hideBack: true }" @changed="loadData" />
			</div>
		</ManageLoanItem>
		<confirm-dlg ref="confirm" />
	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'MemberProfileLoan',
		props: {
			data: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'ManageLoanItem': () => import('@/components/forms/ManageLoanItem.vue'),
			'loan-installments': () => import('@/views/admin/LoanInstallments.vue'),
		},
		data() {
			return {
				localData: null,
				errorMessages: '',
				loading: false,
				tab: '',
			}
		},
		watch: {
			data: {
				deep: true,
				handler(val) {
					this.localData = Object.assign({}, val)
				}
			}
		},
		mounted() {
			this.localData = Object.assign({}, this.data)
		},
		methods: {
			loadData(id = this.localData.id) {
				api.get('admin/userloan/get/' + id, null)
					.then(response => {
						this.localData = response
					})
					.catch(err => {
						toast.error(err.message)
					})
			}
		},
	}
</script>
<style></style>
